import React from "react";
import moment from "moment";
import dialog from '../../../common/utility/dialog';
import { message } from 'antd';
import Header from "../../../components/Header";
import PaginationBase from "../../../common/base/PaginationBase";
import { PAGINATION, FILTER } from "../../../common/types/paginationType";
import global from "../../../common/utility/global";

import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import Filters from "../TipoCambio/Filters";
import ResultList from "../TipoCambio/ResultList";
import FormModal from "../TipoCambio/FormModal";
export default class Index extends PaginationBase {
  constructor(props) {
    super(props);
    this.props.onSetBreadcrumb();
    this.state = {
      filter: {
        fechaInicioStr: global.fetchCurrentDateStr(true),
        fechaFinStr: global.fetchCurrentDateStr(),
        ...FILTER,
      },
      pagination: PAGINATION,
      loadingSource: true,
      loadingExcel: false,
      loadingPdf: false,
      loadingPrint: false,
     
      formValues: this.fetchEmptyFormValues(),
    };
  }

  handleChange = (property, value) => {
    const filter = { ...this.state.filter, [property]: value };
    this.setState({ filter });
};

  handleClearFilters = async () => {
    var filter = {
      fechaInicioStr: global.fetchCurrentDateStr(true),
      fechaFinStr: global.fetchCurrentDateStr(),
        ...FILTER
    };
    this.setState({ filter });
    this._handlePagination(filter);
};

  fetchEmptyFormValues = () => {
    return {
      id: 0,
      fechaStr: global.fetchCurrentDateStr(),
      venta: 0,
      compra: 0,
      ventaComercial: 0,
      compraComercial: 0,
    };
  };

  handleNew = async () => {
    var formValues = this.fetchEmptyFormValues();
    this.setState({
      visible: true,
      formValues,
    });
  };

  handleSave = (values, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
        var response;
        if (values.id === 0)
            response = await tipoCambioDiarioService.registrar(values);
        else
            response = await tipoCambioDiarioService.modificar(values);

        if (response.status === 200) {
            var empty = this.fetchEmptyFormValues();
            form.resetFields();
            this.setState({ visible: false, formValues: empty });

            if (values.id === 0)
                message.success('Registrado correctamente.');
            else
                message.success('Modificado correctamente.');

            this._handlePagination(this.state.filter);
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            return;
        }

        dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
    });
};

handleEdit = async (values) => {
  const response = await tipoCambioDiarioService.obtenerPorId(values.id);
  if (response !== undefined) {
      this.setState({
          visible: true,
          formValues: {
              id: response.id,
              fechaStr: response.fechaStr,
              venta: response.venta,
              compra: response.compra,
              ventaComercial: response.ventaComercial,
              compraComercial: response.compraComercial
          }
      });
  }
};

handleExportExcel = async () => {
  this.setState({ loadingExcel: true });
  var response = await tipoCambioDiarioService.excel(this.state.filter);
  this.setState({ loadingExcel: false });
  if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Tipo de Cambio.xlsx");
}

handleExportPdf = async () => {
  this.setState({ loadingPdf: true });
  var response = await tipoCambioDiarioService.pdf(this.state.filter);
  this.setState({ loadingPdf: false });
  if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Tipo de Cambio.pdf");
}

handlePrint = async () => {
  this.setState({ loadingPrint: true });
  var response = await tipoCambioDiarioService.pdf(this.state.filter);
  this.setState({ loadingPrint: false });
  if (response !== undefined) {
      var file = window.URL.createObjectURL(response.data);
      var win = window.open(file, '_blank');
      win.focus();
  }
}

  
  async componentDidMount() {
    this._initPagination(this.state.filter, tipoCambioDiarioService.paginacion);
    this.setState({
      loadingSource: false
  });
  };

  render() {
    return (
      <div>
        <Header
          title="Tipo de Cambio"
          onNew={this.handleNew}
          loadingNew={this.state.loadingSource || this.state.loadingNew}
            onSearch={() => this._handlePagination(this.state.filter)}
          onClearFilters={this.handleClearFilters}
        />
        <Filters
          filter={this.state.filter}
          onKeyUpSearch={this.handleKeyUpInput}
          onChange={this.handleChange}
        />

        <ResultList
          pagination={this.state.pagination}
          loadingEdit={this.state.loadingSource}
          loadingExcel={this.state.loadingExcel}
          loadingPdf={this.state.loadingPdf}
          loadingPrint={this.state.loadingPrint}
          onExportExcel={this.handleExportExcel}
          onExportPdf={this.handleExportPdf}
          onPrint={this.handlePrint}
          onEdit={this.handleEdit}
          onChange={this._handleChangePagination}
        />

        <FormModal
          visible={this.state.visible}
          formValues={this.state.formValues}
          onClose={() => this.setState({ visible: false })}
          onSave={this.handleSave}
        />
      </div>
    );
  }
}
